/**
 * Formatação das avaliações. Em arquivo separado dos componentes porque o
 * Fast Refresh do Vite só funciona em módulos que exportam apenas componentes.
 */

/** "4,9" — vírgula como separador decimal, sempre uma casa. */
export function formatarNota(nota: number) {
  return nota.toLocaleString("pt-BR", {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  });
}

/** "agosto de 2026" — mês e ano bastam; dia exato só chama atenção para idade. */
export function formatarMesAno(iso: string | null) {
  if (!iso) return "";
  const data = new Date(iso);
  if (Number.isNaN(data.getTime())) return "";
  return data.toLocaleDateString("pt-BR", { month: "long", year: "numeric" });
}
